import React from 'react'
import { Sidebar } from '../../../components/Sidebar/Sidebar'
import './ViewSubject.css'
import DataTable from 'react-data-table-component'
import { TiDeleteOutline } from 'react-icons/ti'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useEffect } from 'react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link } from 'react-router-dom'

export const ViewSubject = () => {
  toast.configure()
  // set input values
  const [values, setValues] = useState({ subname: '' })
  const [subjects, setSubjects] = useState([])
  const [subject, setSubject] = useState()
  const [id, setId] = useState()

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
    setSubject({ ...subject, [name]: value })
  }

  // get declared subjects
  const getSubjects = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'subject/fetchAllSubjects')
      .then((res) => {
        setSubjects(res.data.data)
      })
      .catch((error) => {})
  }
  useEffect(() => {
    getSubjects()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // add new subject
  const postSubject = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'subject/addSubject', {
        sub_name: values.subname,
      })
      .then((res) => {
        // on success clear field
        setValues({ subname: '' })
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
      })
  }

  // delete selected subject
  const deleteSubject = async (id) => {
    await axios
      .post(Baseurl.nodeLocal + 'subject/deleteSubject', {
        sub_id: id,
      })
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  // columns to display added subjects
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.sub_id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Subject title',

      selector: (row) => row.name,
      sortable: true,
    },

    {
      name: 'Action',
      cell: (row) => (
        <>
          {/* <MdEdit
            className="editbtn"
            data-bs-target="#editModal"
            data-bs-toggle="modal"
            onClick={() => {
              fetchSubject(row.sub_id)
            }}
          /> */}

          <TiDeleteOutline
            className="deletebtn"
            data-bs-target="#deletemodal"
            data-bs-toggle="modal"
            onClick={() => {
              setId(row.sub_id)
            }}
          />
        </>
      ),
    },
  ]

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-9 mx-5 mt-4 p-2">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add/View Subjects
              </li>
            </ol>
          </nav>
        </div>
        <div className="viewSubheader">
          <h4>Add/View Subjects</h4>
        </div>
        <div className="row">
          <div
            className="addSubject mt-5 p-3 card col-md-4"
            style={{ maxHeight: '200px' }}
          >
            <p style={{ fontSize: '23px' }}>Add Subject</p>
            {/* add subject form */}
            <form onSubmit={postSubject}>
              <div className="form-group mt-2">
                <label for="cardNumber">
                  <h6>Subject Title</h6>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject Title"
                    name="subname"
                    value={values.subname}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mt-2">
                  <button className="btn btn-primary btn-sm">Submit</button>
                </div>
              </div>
            </form>
          </div>
          <div className="subject mt-5 col-md-6 p-2 ">
            {/* data table to display declared subjects */}
            <DataTable
              title="View Subjects"
              columns={columns}
              data={subjects}
              pagination
              highlightOnHover
            />
          </div>
        </div>
      </div>
      {/* modal for confirmation of deletion */}
      <div
        className="modal"
        tabIndex="-1"
        id="deletemodal"
        aria-labelledby="deletemodalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete the data ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => deleteSubject(id)}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
